module.exports = __webpack_public_path__ + "img/photo3@2x.08aa2e96.jpg";